"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import Hamburger from "components/icons-svg/Hamburger";
import useListOfPromocodes from "hooks/swr/useListOfPromocodes";
import { useSendbirdContext } from "sendbird/useSendbirdContext";
import { selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
import { isPresidentsDayDealsContext } from "utils/presidentsDayDeals";
import { LogInToPortalButton } from "./LogInToPortalButton";
import { WelcomeUserText } from "./WelcomeUserText";
const AppDesktopHeaderMenu = dynamic(() => import( /* webpackChunkName: "AppDesktopHeaderMenu" */"./AppDesktopHeaderMenu"), {
  loading: () => {
    return <button aria-label='open menu' className='btn btn-ghost rounded-md p-0 outline-none lg:h-12'>
          <Hamburger className='h-4 w-4 fill-[#fff]' />
        </button>;
  },
  ssr: false
});
const AppHeaderRight = () => {
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  const isPresidentsDeals = isPresidentsDayDealsContext(pathname);
  const [hasMounted, setHasMounted] = useState(false);
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const {
    unreadCount
  } = useSendbirdContext();
  const {
    data: promoCodesList
  } = useListOfPromocodes();
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) return null;
  const headerTextClassName = isPresidentsDeals ? "text-[#0B4F57]" : "text-white";
  return <div className={`flex min-w-max items-center justify-end gap-2 md:py-4 ${headerTextClassName}`} data-sentry-component="AppHeaderRight" data-sentry-source-file="AppHeaderRight.tsx">
      {!isPaymentPage && <LogInToPortalButton className={headerTextClassName} />}
      <WelcomeUserText className={headerTextClassName} data-sentry-element="WelcomeUserText" data-sentry-source-file="AppHeaderRight.tsx" />

      <div className='z-[1001]'>
        {(isLoggedIn || !isLoggedIn && !isPaymentPage) && <AppDesktopHeaderMenu unreadCount={unreadCount} promoCodesList={promoCodesList} buttonTextClassName={headerTextClassName} />}
      </div>
    </div>;
};
export default AppHeaderRight;